/*
 * Copyright (c) 2022. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import abstractContractClaimTranslations from "./abstractContractClaimTranslations";

const membershipContractTranslations = {
  label: "Mitgliedschaft",
  reasonForDispute: {
    question: "Welches Problem haben Sie mit dem Vertragspartner?",
    label: "Problem mit Ihrem Vertragspartner",
    options: {
      cancellationByContractPartner: {
        label: "Vertrag wurde von Vertragspartner gekündigt",
        optionHintText: "Ihr Vertrag wurde ohne Ihre Zustimmung vom Vertragspartner gekündigt. Sie möchten den Vertrag weiterhin aufrecht erhalten.",
      },
      priceIncrease: {
        label: "Vertragspartner hat die Preise erhöht",
        optionHintText: "Der Vertragspartner hat die Preise oder den Abschlag erhöht - dagegen möchte ich vorgehen.",
      },
      cancellationRefused: {
        label: "Meine Kündigung wird nicht akzeptiert",
        optionHintText: "Sie haben regulär oder außerordentlich gekündigt und der Vertragspartner hat Ihre Kündigung nicht akzeptiert.",
      },
      invoiceIncorrect: {
        label: "Fehlerhafte Rechnung erhalten",
        optionHintText: "Der Vertragspartner behauptet, dass die Rechnung korrekt ist. Sie möchten sich nun dagegen wehren.",
      },
      other: {
        label: "Anderes Problem oder Frage",
        optionHintText: "Sie können uns Ihr Problem in den folgenden Schritten noch genauer erklären.",
      },
    },
  },
  membershipType: {
    label: "Art der Mitgliedschaft",
    question: "Um welche Art von Mitgliedschaft handelt es sich?",
    options: {
      gym: { label: "Fitnessstudio" },
      club: { label: "Verein" },
      other: { label: "Andere Mitgliedschaft" },
    },
  },
  contractNumber: {
    question: "Wie lautet Ihre Vertrags- oder Mitgliedsnummer?",
    label: "Vertrags-/Mitgliedsnummer",
    helperText: "Sie finden diese Nummer z.B. auf Ihren Rechnungen oder in Ihrem Mitgliedschaftsvertrag",
  },
  cancellationDate: {
    question: "Wann haben Sie Ihre Kündigung abgeschickt?",
    label: "Kündigungsdatum",
  },
  cancellationReceivedDate: {
    question: "Wann haben Sie die Kündigung vom Vertragspartner erhalten?",
    label: "Eingang der Kündigung",
  },
  endOfContractDate: {
    question: "Zu welchem Datum sollte der Vertrag Ihrer Ansicht nach enden?",
    label: "Datum Vertragsende",
  },
  numberUnpaidPeriods: {
    label: "Anzahl nicht bezahlter Perioden",
    question: (caseData: Record<string, any>) => {
      switch (caseData.feePaymentFrequency) {
        case "monthly":
          return "Haben Sie Beiträge NICHT gezahlt, und falls ja, wie viele Monate haben Sie im relevanten Zeitraum nicht gezahlt?";
        case "quarterly":
          return "Haben Sie Beiträge NICHT gezahlt, und falls ja, wie viele Quartale haben Sie im relevanten Zeitraum nicht gezahlt?";
        case "yearly":
          return "Haben Sie Beiträge NICHT gezahlt, und falls ja, wie viele Jahre haben Sie im relevanten Zeitraum nicht gezahlt?";
      }
    },
    helperText:
      "Wenn Sie zum Beispiel monatlich zahlen und zwei Monate lang nicht gezahlt haben, geben Sie hier eine “2” ein. Wenn Sie durchgehend gezahlt haben, tragen Sie bitte “0” ein.",
  },
  feePaymentFrequency: {
    label: "Zahlung erfolgt",
    question: "Wie bezahlen Sie die Beiträge für Ihre Mitgliedschaft?",
    options: {
      monthly: { label: "monatlich" },
      quarterly: { label: "quartalsweise" },
      yearly: { label: "jährlich" },
    },
  },
  priceIncreaseAnnouncementDate: {
    question: "Falls der Vertragspartner die Preiserhöhung angekündigt hat, wann ist diese bei Ihnen eingegangen?",
    label: "Datum Ankündigung Preiserhöhung",
    helperText: "Falls Sie keine Ankündigung erhalten haben, lassen Sie das Feld einfach leer.",
  },
  opponentReactionToCancellation: {
    question: "Wie ist die Gegenseite mit Ihrer Kündigung umgegangen?",
    label: "Reaktion Gegenseite auf Kündigung",
    options: {
      noReaction: { label: "Keine Reaktion", optionHintText: "Meine Kündigung wurde ignoriert" },
      cancellationRefused: {
        label: "Kündigung abgelehnt",
        optionHintText: "Meine Kündigung wurde vollständig abgelehnt",
      },
      differentDate: {
        label: "Anderes Kündigungsdatum/Verlängerung",
        optionHintText: "Mir wurde ein anderes Ende des Vertrages genannt, oder der Vertrag wurde über das von mir errechnete Vertragsende hinaus verlängert.",
      },
    },
  },
  endOfContractDateOpponent: {
    question: "Zu welchem Datum endet laut Gegenseite Ihr Vertrag?",
    label: "Vertragsende laut Gegenseite",
  },

  fee: {
    label: "Mitgliedsbeitrag",
    question: (caseData: Record<string, any>) => {
      switch (caseData.feePaymentFrequency) {
        case "monthly":
          return "Welchen Betrag zahlen Sie monatlich?";
        case "quarterly":
          return "Welchen Betrag zahlen Sie pro Quartal?";
        case "yearly":
          return "Welchen Betrag zahlen Sie jährlich?";
      }
    },
  },
  ...abstractContractClaimTranslations,
};

export default membershipContractTranslations;
